module.exports = __webpack_public_path__ + "img/rumblefish-logo.29ea025b.svg";